import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ErrorBoundary from './components/layout/ErrorBoundary';

const MainLayout = React.lazy(() => import('./views/MainLayout'));
const Showcase = React.lazy(() => import('./views/showcase'));
const Store = React.lazy(() => import('./views/store'));
const About = React.lazy(() => import('./views/about'));
const Cart = React.lazy(() => import('./views/cart'));
const Account = React.lazy(() => import('./views/account'));
const AdminView = React.lazy(() => import('./views/admin').then(m => ({ default: m.AdminView })));
const CheckoutForm = React.lazy(() => import('./views/checkout').then(m => ({ default: m.CheckoutForm })));
const Return = React.lazy(() => import('./views/checkout').then(m => ({ default: m.Return })));
const PrivacyPolicy = React.lazy(() => import('./views/privacy-policy'));
const DataDeletion = React.lazy(() => import('./views/data-deletion'));
const ResetPassword = React.lazy(() => import('./views/reset-password'));
const VerifyEmail = React.lazy(() => import('./views/verify-email'));
const Error404 = React.lazy(() => import('./views/error/404'));


function App() {
  return (
    <div className="main">
      <ErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Suspense fallback={
          <main className='content'>
            Loading...
          </main>
        }>
          <Routes>
            <Route path='/' element={<MainLayout />}>
              <Route index element={<Showcase />} />
              <Route path='/store' element={<Store />} />
              <Route path='/about' element={<About />} />
              <Route path='/cart' element={<Cart/>} />
              <Route path='/account' element={<Account />} />
              <Route path='/admin' element={<AdminView />} />
              <Route path='/checkout' element={<CheckoutForm />} />
              <Route path='/return' element={<Return />} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/data-deletion' element={<DataDeletion />} />
              <Route path='/reset-password' element={<ResetPassword />} />
              <Route path='/verify-email' element={<VerifyEmail />} />
              <Route path='*' element={<Error404 />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
